import api from "../api";

const payment = async (startTime, endTime, planId, storeSimulatorId, returnUrl) => {
  // Set seconds to 0 and add 8 hours
  const startDate = new Date(startTime);
  startDate.setSeconds(0, 0);
  startDate.setHours(startDate.getHours() + 8);
  const endDate = new Date(endTime);
  endDate.setSeconds(0, 0);
  endDate.setHours(endDate.getHours() + 8);

  const requestData = {
    startTime: startDate.toISOString(), // 開始時間 如果預定11:00~12:00 需往前-10分鐘
    endTime: endDate.toISOString(), // 結束時間 如果預定11:00~12:00 需往後+10分鐘
    planId: planId, // 方案ID
    status: "pending", // 固定
    storeSimulatorId: storeSimulatorId, // 包廂ID
    returnUrl: returnUrl
  };
  try {
    console.log("[payment] request:", requestData);
    const response = await api.post(
      process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/appointment/simulator/credit",
      requestData
    );
    console.log("[payment] response:", response.data);
    return response.data;
  } catch (error) {
    console.error("[payment] error status:", error.response?.status);
    console.error("[payment] error statusText:", error.response?.statusText);
    console.error("[payment] error data:", error.response?.data);
    console.error("[payment] error headers:", error.response?.headers);
    console.error("[payment] full error:", error);
    throw error;
  }
};

export default payment;
